import { SVGProps } from 'react';

const JustDriveOut = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M10.711 4h-5.2c-.662 0-1.214.421-1.425 1.013L2 11.021v8.025l.003 1.003h2.006c-.003-.049-.003-1.003-.003-1.003v-1.003h6.705v-2.006H4.006V11.02h6.705V9.126H4.778l1.084-3.12h4.85zm6.513 11.032 3.553-3.714L22 10.04l-1.223-1.278-3.553-3.71-1.223 1.28 2.69 2.808H13.19v1.807h5.503L16 13.754zM6.893 12.526a1.128 1.128 0 1 0 0 2.257 1.128 1.128 0 0 0 0-2.257"
      clipRule="evenodd"
    />
  </svg>
);
export default JustDriveOut;
